import React from 'react';
import './LevelUpBanner.css';

interface LevelUpBannerProps {
  characterName: string;
  oldLevel: number;
  newLevel: number;
}

// Mid-battle level-up moment (GH-75) - the victory screen already celebrates XP gains,
// but nothing marked the instant a character actually leveled up during the fight.
const LevelUpBanner: React.FC<LevelUpBannerProps> = ({ characterName, oldLevel, newLevel }) => {
  return (
    <div className="level-up-banner-overlay">
      <div className="level-up-banner">
        <div className="level-up-banner-title">⭐ LEVEL UP! ⭐</div>
        <div className="level-up-banner-name">{characterName}</div>
        <div className="level-up-banner-levels">
          <span className="level-up-old">{oldLevel}</span>
          <span className="level-up-arrow">→</span>
          <span className="level-up-new">{newLevel}</span>
        </div>
      </div>
    </div>
  );
};

export default LevelUpBanner;
